export default {
  EMAIL: "Email",
};
